import { Injectable, inject } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class VentasCementoUiEffectsService {
  private readonly toast = inject(ToastService);
  private readonly spinner = inject(NgxSpinnerService);

  syncLoading(isLoading: boolean): void {
    if (isLoading) {
      this.spinner.show();
      return;
    }
    this.spinner.hide();
  }

  showLoadError(): void {
    this.toast.showAdminError('No se pudieron cargar las ventas.');
  }

  showExcelSuccess(): void {
    this.toast.showAdminSuccess('Excel generado correctamente.');
  }

  showExcelError(): void {
    this.toast.showAdminError('Error al generar el Excel.');
  }
}
